/**
 * Include your custom JavaScript here.
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function WQtyExc() {
  let wQtyEl = this.parentElement;
  let wQtyInput = wQtyEl.querySelector(".wQtyInput");
  let shopifyQty = wQtyEl.querySelector('input[name="quantity"]');

  var step = 1;
  var decimal = 0;
  var min = 1;
  var max = 999999;
  var conversion = 1;
  var line = false;

  if (wQtyEl.getAttribute("data-step")) {
    step = wQtyEl.getAttribute("data-step");
  }
  if (wQtyEl.getAttribute("data-decimal")) {
    decimal = wQtyEl.getAttribute("data-decimal");
  }
  if (wQtyEl.getAttribute("data-min")) {
    min = wQtyEl.getAttribute("data-min");
  }
  if (wQtyEl.getAttribute("data-max")) {
    max = wQtyEl.getAttribute("data-max");
  }
  if (wQtyEl.getAttribute("data-conversion")) {
    conversion = wQtyEl.getAttribute("data-conversion");
  }
  if (wQtyEl.getAttribute("data-line")) {
    line = wQtyEl.getAttribute("data-line");
  }

  var NewValue = Number(wQtyInput.value);

  if (this.getAttribute("data-type") === "decrease") {
    NewValue = NewValue - Number(step);
  } else if (this.getAttribute("data-type") === "increase") {
    NewValue = NewValue + Number(step);
  }

  NewValue = Number(NewValue.toString().replace(/[^0-9\.]/g, ""));
  if (NewValue < min) {
    NewValue = min;
  }
  if (NewValue > max) {
    NewValue = max;
  }
  NewValue = Number(NewValue).toFixed(decimal);
  NewValue = NewValue.toString().replace(",", ".");
  wQtyInput.value = NewValue;

  shopifyQty.value = Number(NewValue) * Number(conversion);

  if (window.theme.pageType === "cart" && window.theme.cartType === "drawer") {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    fetch("".concat(window.routes.cartChangeUrl, ".js"), {
      body: JSON.stringify({
        line: line,
        quantity: shopifyQty.value,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (cart) {
      cart.json().then(function (content) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );

        // document.documentElement.dispatchEvent(
        //   new CustomEvent("product:added", {
        //     bubbles: true,
        //     detail: {
        //       quantity: content["items"].length,
        //     },
        //   })
        // );

        // document.querySelector(".header__cart-count").textContent =
        //   content["items"].length;
        // document.dispatchEvent(new CustomEvent("theme:loading:end"));

        // _this.itemCount = content['item_count'];
        // _this._rerender(false).then(function () {
        //   document.dispatchEvent(new CustomEvent('theme:loading:end'));
        // });
      });
    });
    //event.preventDefault();

    //window.location.href = "".concat(window.routes.cartChangeUrl, "?line=").concat(line, "&quantity=").concat(shopifyQty.value);
    return;
  }

  return;
}

document.querySelector("body").addEventListener("change", ({ target }) => {
  if (target.matches(".wQtyInput")) {
    var WQtyExc2 = WQtyExc.bind(target);
    WQtyExc2();
  }
});
document.querySelector("body").addEventListener("click", ({ target }) => {
  if (target.matches(".wQtyCtrl")) {
    var WQtyExc2 = WQtyExc.bind(target);
    WQtyExc2();
  }
});

function extractStrBetween(fullStr, str1, str2) {
  let result = "";
  let regExpression = new RegExp(`${str1}([^${str2}]+)${str2}`);
  let extracted = regExpression.exec(fullStr);
  if (extracted != undefined) {
    result = extracted[1];
  }
  return result;
}

/*
document.querySelectorAll('.wQtyInput').forEach(item => {
  item.addEventListener('change', WQtyExc, false);
});
document.querySelectorAll('.wQtyCtrl').forEach(item => {
  item.addEventListener('click', WQtyExc, false);
});
*/